import React, {Component} from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Icons from "../../../../../icon";
import Translation from "../../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { ORFButton } from "../../../../../common/forms/order-request-form.component";
import { Col, Form, Row } from "react-bootstrap";
import { wirelessChangeVendorActions } from "../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer";
import { createRequestActions } from "../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "../../../../../../store/external/request-reducer/request-log.reducer";
import { SUBMIT_REQUEST, MODAL_TITLE, SUBMIT_REQUEST_TITLE, BUSINESS_CASE } from "../../../../../../constants/external-constants";
import {
    OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions,
    ORFCheckbox
} from '../../../../../common/forms/order-request-form.component';
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { Milestone } from "../../../../../common/milestone/milestone.component";
import { withRouter } from 'react-router-dom';
import { ConfirmationNotificationModal } from "../../../../../common/modal/confirmation-modal.component";
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import store from '../../../../../../store';
import { actions } from 'react-redux-form';
class ChangeVendorBusinessFormA extends Component {

    constructor(props) {
        super(props);
        this.state={
            show:false,
            message:"",
            isSaving:false, 
            showConModal:false,
            title: "",
          
        }
    }

    componentDidMount() {
        const { isUpdateRequest } = this.props.createRequest;
        const { requestDetail, wirelessChangeVendorFormA } = this.props;     
        const { businessCaseOptions } = this.props.wirelessChangeVendorRequest;
        if (isUpdateRequest && requestDetail.requestData.BusinessJustification.BusJustiCodeDetailId != 0 && businessCaseOptions.findIndex(r => r.Key == requestDetail.requestData.BusinessJustification.BusJustiCodeDetailId && r.Value.toLowerCase() == 'other') > -1) {
            this.setState({ disableBusinessJustification: false })
        }      
        if (wirelessChangeVendorFormA.busJustiCodeDetailId == 0 || businessCaseOptions.findIndex(r => r.Key == wirelessChangeVendorFormA.busJustiCodeDetailId && r.Value.toLowerCase() != 'other') > -1) {
            this.setState({ disableBusinessJustification: true })
        }            
  }  
    submitRequest = (event) => {
        event.preventDefault();
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
      
        if (buttonType === CONFIRMATION_VALUE.Ok) {
              const { submitRequest, fetchRequestLogItems } = this.props;
              this.setState( prev => ({
                isSaving:true,
             }))
                var success = await submitRequest();
                if (success.Success) {
                    fetchRequestLogItems(0);
                    this.setState({
                        title:"Success"
                    })
                    this.props.hideRequestModal(); 
                }else {
                    this.setState({
                        title:"Error"
                    })
                }
                this.setState( prev => ({
                    showConModal: !prev.showConModal,
                    show:true, 
                    isSaving:true,
                    message:success.Message
                }));                
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {           
            this.props.history.goBack();
        } 
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onChangeBusinessCase(model, value) {
        const { businessCaseOptions } = this.props.wirelessChangeVendorRequest;

        var disableBusinessJustification = businessCaseOptions.findIndex(r => r.Key == value && r.Value.toLowerCase() != 'other') > -1;
        var businessCaseSelected = businessCaseOptions.find(r => r.Key == value);
        var businessJustificationValue = disableBusinessJustification == true ? businessCaseSelected?.Value : "";

        store.dispatch(actions.change(model, value));
        store.dispatch(actions.change("wirelessChangeVendorFormA.businessJustification", businessJustificationValue));
        this.setState({
            disableBusinessJustification: disableBusinessJustification
        });
    }

    render(){

        const {
            //form
            wirelessChangeVendorFormA
            //reducer action
            , setRequestorAddress
            , onSubscriptionSelect
            , fetchSubscriptionByValue
            , onVendorSelect
            , onPlanSelect
            , onOtherPlanSelect
            , onOrderSelect
            , onServiceTypeSelect
            , onAccessorySelect
            , onCountrySelect
            , onAddressSelect
            , onPurposeOfUseSelect
            , onBusinessCaseSelect
        } = this.props;
        const {
            requestData
        } = this.props.requestDetail;
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { preferredVendorOptions
            , userLocation
            , accountOptions
            , planOptions
            , otherPlanOptions
            , simOptions
            , orderOptions
            , deviceOptions
            , countryOptions
            , addressOptions
            , businessCaseOptions
            , purposeOfUseOptions
            , planDetails
            , vendorDetails
            , serviceTypeDetail
            , showDeviceOptions
            , deviceAccessories
            , showPreferredAddress
            , formSubmitted
            , subscription } = this.props.wirelessChangeVendorRequest;

        const initialRequired = wirelessChangeVendorFormA.circuitId == 0
            || wirelessChangeVendorFormA.newVendorId == 0
            || wirelessChangeVendorFormA.equipmentCatalogId == 0
            //|| wirelessChangeVendorFormA.orderOptionId == 0
            //|| wirelessChangeVendorFormA.newAccountId == 0
            || wirelessChangeVendorFormA.newPlanId == 0
            || wirelessChangeVendorFormA.planDetailsModel.length == 0
            //|| wirelessChangeVendorFormA.newSimTypeId == 0
            || wirelessChangeVendorFormA.businessJustification == ''
            || wirelessChangeVendorFormA.countryCode == ''
            || wirelessChangeVendorFormA.locationId == ''
            || wirelessChangeVendorFormA.busJustiCodeDetailId == 0
            || wirelessChangeVendorFormA.businessJustification == ''
            || wirelessChangeVendorFormA.purposeOfUseDetailId == 0
            || formSubmitted;

        const updateRequired = !((requestData.OtherLocationName != '' ? requestData.OtherLocationName != wirelessChangeVendorFormA.otherDeliveryAddress : wirelessChangeVendorFormA.otherDeliveryAddress != null)
            || requestData.BillingAddress.LocationId != wirelessChangeVendorFormA.locationId
            || requestData.BillingAddress.CountryCode != wirelessChangeVendorFormA.countryCode
            || requestData.NewRequest.PlanDetails.PlanId != wirelessChangeVendorFormA.newPlanId
            || requestData.Subscription.PhoneCaseAccessory != wirelessChangeVendorFormA.isPhoneAccessory
            || requestData.Subscription.EquipmentInventoryId != wirelessChangeVendorFormA.equipmentCatalogId
            || requestData.NewRequest.CircuitTypeId != wirelessChangeVendorFormA.circuitTypeId
            || requestData.NewRequest.Vendor.VendorDetailId != wirelessChangeVendorFormA.newVendorId
            || requestData.BusinessJustification.PurposeOfUseId != wirelessChangeVendorFormA.purposeOfUseDetailId
            || requestData.BusinessJustification.BusJustiCodeDetailId != wirelessChangeVendorFormA.busJustiCodeDetailId
            || requestData.BusinessJustification.BusinessJustification != wirelessChangeVendorFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelessChangeVendorFormA.additionalInformation);
       
        // if (showDeviceOptions) {
        //     disable = disable || wirelessChangeVendorFormA.equipmentCatalogId == 0;
        // }

        // if (showPreferredAddress) {
        //     disable = disable || wirelessChangeVendorFormA.otherDeliveryAddress == '';
        // }

        const accessoryCost = wirelessChangeVendorFormA.accessoryDetailsModel.length > 0 ?
            wirelessChangeVendorFormA.accessoryDetailsModel.reduce((accum, item) => accum + item.OrderCost, 0) : 0;


        return(
            <div>

                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    disabled={this.state.isSaving}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <Form 
                    role="form"
                    model="wirelessChangeVendorFormA"
                    onSubmit={this.submitRequest}
                >            
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={<Translation translationKey="purpose_of_use" />}
                                options={purposeOfUseOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='wirelessChangeVendorFormA.purposeOfUseDetailId'
                                value={wirelessChangeVendorFormA.purposeOfUseDetailId}
                                onChangeAction={onPurposeOfUseSelect}
                                disabled={wirelessChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={<Translation translationKey="business_case" />}
                                options={businessCaseOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='wirelessChangeVendorFormA.busJustiCodeDetailId'
                                value={wirelessChangeVendorFormA.busJustiCodeDetailId}
                                onChangeAction={(model, value) => this.onChangeBusinessCase(model, value)}                          
                            />
                        </Col>
                    </Row>
                    <Row>   
                        <Col xs={12} md={12} lg={12} className='required'>
                            <TextArea
                                label={<Translation translationKey="business_justification" />}
                                fieldProp='wirelessChangeVendorFormA.businessJustification'
                                value={wirelessChangeVendorFormA.businessJustification}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                disabled={this.state.disableBusinessJustification}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={<Translation translationKey="additional_information" />}
                                fieldProp='wirelessChangeVendorFormA.additionalInformation'
                                value={wirelessChangeVendorFormA.additionalInformation}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                disabled={wirelessChangeVendorFormA.circuitId == 0}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>

                    <div className="request-button-continer">
                            <div className="bottom-left">
                                <ORFButton
                                    label={<Translation translationKey="modal_close_cancel_button" />}
                                    variant={"light"}
                                    action={this.props.onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <ORFButton
                                        label={<Translation translationKey="back" />}
                                        variant={"outline-secondary"}
                                        action={this.props.prevAction}
                                        type="button"
                                        className="btn-custom-violet-hover-outline"
                                    />
                                </div>
                                <div>
                                    <ORFButton
                                        label={<Translation translationKey="submit_request_button" />}
                                        variant={"primary"}
                                        type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired }
                                    />
                                </div>
                            </div>
                    </div> 
                    
                </Form>            
               
            </div>
        );
    }
}

export default withRouter ( connect(
    state => {
        const { wirelessChangeVendorRequest, createRequest, requestDetail, translation } = state;
        const { wirelessChangeVendorFormA } = state.form;
        return {
            wirelessChangeVendorRequest
            , wirelessChangeVendorFormA
            , createRequest
            , requestDetail
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessChangeVendorActions, createRequestActions, requestLogActions),
            dispatch
        )
)(ChangeVendorBusinessFormA));